import {createSelector} from "@reduxjs/toolkit";
import {AppState} from "../../../../shared/redux/rootReducer";

export const notificationsSelector = createSelector((state: AppState) => state.snack.notifications,
  (x => x));
